import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '../../IconButton';

const CustomToolbar = ({ title, icon }) => (
  <Toolbar>
    <Typography
      sx={{ flex: '1 1 100%' }}
      variant="h6"
      id="tableTitle"
    >
      {title}
    </Typography>
    {icon && (
      <Tooltip title="Invite User">
        <div>
          <IconButton
            Icon={AddCircleIcon}
            aria-label="add"
            color="#fff"
            href="/invite"
          />
        </div>

      </Tooltip>
    )}

  </Toolbar>
);

export default CustomToolbar;
